import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { useSiteConfig, pickI18n } from '../contexts/SiteConfigContext';
import * as Icons from 'lucide-react';

const getIcon = (name) => Icons[name] || Icons.Sparkles;

const Services = ({ hideHeader = false }) => {
  const { lang } = useLang();
  const { config } = useSiteConfig();
  const colors = config.identity?.colors || {};
  const services = (config.services || []).filter((s) => s.visible !== false);

  const tagText = lang === 'de' ? 'Unsere Leistungen' : lang === 'ar' ? 'خدماتنا' : 'Our Services';
  const titleText =
    lang === 'de' ? 'Entdecken Sie unsere Services'
    : lang === 'ar' ? 'اكتشفي خدماتنا المميزة'
    : 'Discover Our Services';

  return (
    <section id="services" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {!hideHeader && (
          <div className="text-center mb-16 lg:mb-20">
            <p
              className="text-xs md:text-sm mb-4 tracking-[0.3em] uppercase font-medium"
              style={{ color: colors.accent || '#b54e7d' }}
            >
              {tagText}
            </p>
            <h2
              className="font-display"
              style={{
                color: colors.text_dark || '#5a1d3b',
                fontSize: 'clamp(1.875rem, 3vw, 2.75rem)',
                fontWeight: 500,
                letterSpacing: '-0.01em',
              }}
            >
              {titleText}
            </h2>
            <div
              className="w-16 h-px mx-auto mt-8 opacity-40"
              style={{ backgroundColor: colors.primary || '#c4477a' }}
            />
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 lg:gap-7">
          {services.map((s) => {
            const Icon = getIcon(s.icon);
            return (
              <div
                key={s.id}
                className="group bg-white rounded-2xl p-8 text-center transition-all duration-500 hover:-translate-y-1"
                style={{
                  boxShadow:
                    '0 1px 3px rgba(196, 71, 122, 0.06), 0 8px 24px -10px rgba(196, 71, 122, 0.12)',
                }}
              >
                {s.image ? (
                  <img
                    src={s.image}
                    alt=""
                    className="w-20 h-20 mx-auto mb-5 object-cover rounded-full"
                  />
                ) : (
                  <div className="mb-6 flex justify-center">
                    <Icon
                      className="w-14 h-14"
                      strokeWidth={1.4}
                      style={{ color: colors.primary || '#c4477a' }}
                    />
                  </div>
                )}
                <h3
                  className="font-display mb-3"
                  style={{
                    color: colors.text_dark || '#5a1d3b',
                    fontSize: '1.25rem',
                    fontWeight: 500,
                  }}
                >
                  {pickI18n(s.name, lang)}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {pickI18n(s.description, lang)}
                </p>
                {s.price && (
                  <p
                    className="mt-3 font-medium"
                    style={{ color: colors.primary || '#c4477a' }}
                  >
                    {s.price}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
